import React from 'react';
import dayjs from 'utils/dayjs';
import './statusOverviewTooltip.style.css';

const statusOverviewTooltip = (props) => {
    const { active, payload, formatter } = props;
    if (!(active && payload)) return null;

    const dataPoint = payload[0].payload;
    return (
        <div className="StatusOverviewTooltip">
            <div className="StatusOverviewTooltip-header">{dayjs(dataPoint.stayDate).format('ddd DD MMM YYYY')}</div>

            <div className="StatusOverviewTooltip-content">
                <div className="StatusOverviewTooltip-content-section">
                    {payload.map((row) => (
                        <p key={row.name}>
                            <span>{row.name}: </span>
                            {formatter(row.value)}
                        </p>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default statusOverviewTooltip;
